<div class="p-grid">
  <div class="p-col-8">
    <p-scrollpanel [style]="{width: '100%', height: '92vh'}">
      <p-panel [header]="header" class="topHeader multiDayJobsPanel">
        @if (type == 'wellness') {
          <app-multiday-jobs-panel></app-multiday-jobs-panel>
        }
        @if (type == 'work') {
          <app-multiday-jobs-work-panel></app-multiday-jobs-work-panel>
        }
      </p-panel>
    </p-scrollpanel>
  </div>
  <div class="p-col-4">
    <p-scrollpanel [style]="{width: '100%', height: '92vh'}">
      <app-multiday-equipment-and-employees></app-multiday-equipment-and-employees>
    </p-scrollpanel>
  </div>
</div>